import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import * as dataActions from '@/data/data-actions';
import * as dataSelectors from '@/data/data-selectors';
import * as userActions from '@/user/user-actions';
import { PlaceSelection } from '@/user/user-profile/place-selection';
import * as userSelectors from '@/user/user-selectors';
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
import styled from 'styled-components';
import { FormWrapper } from '../user-profile/user-profile-styles';
import { ReportDownload } from './report-download';
import { toaster } from '@/utils/toaster';

const Wrapper = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;
  width: 900px;
  justify-content: center;

  > * {
    margin-right: 15px;
    min-height: 300px;
    max-width: 360px;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #eef4ff;
    border-radius: 10px;
    padding-top: 15px;
  }
`;

function AdminDashboardComponent(props) {
  const { setCurrentCity, currentCity } = props;

  const applyPlaceAndMode = useCallback(
    (selectedPlace, includeCities) => {
      if (strOracleApiSender.getIncludeCities() !== includeCities) {
        strOracleApiSender.setIncludeCities(includeCities);
        toaster.success(
          `Mode set to: ${JSON.stringify(strOracleApiSender.mode)}`
        );
      }
      if (selectedPlace) {
        console.info(`switching to ${selectedPlace}`); // eslint-disable-line no-console
        setCurrentCity(selectedPlace);
      }
    },
    [setCurrentCity]
  );

  return (
    <Wrapper>
      <PlaceSelection
        className={props.className}
        currentPlace={currentCity}
        currentIncludeCities={strOracleApiSender.getIncludeCities()}
        stats={props.stats}
        onCurrentPlaceAndModeChange={applyPlaceAndMode}
      />
      <ReportDownload />
    </Wrapper>
  );
}

function mapStateToProps(state) {
  return {
    currentCity: userSelectors.currentCity(state),
    stats: dataSelectors.stats(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentCity: (city) =>
      dispatch(userActions.setCurrentCityEverywhere({ city })),
  };
}

export const AdminDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminDashboardComponent);
